import React from "react";
import { Polyline } from "@react-google-maps/api";

const RoutePolylines = ({ fullPath, pathDirection, routePaths, routeColor }) => {
  // Always show full route in route color
  if (fullPath.length > 0) {
    return (
      <Polyline
        path={fullPath}
        options={{
          strokeColor: routeColor || "#2196F3",
          strokeOpacity: 1,
          strokeWeight: 6,
        }}
      />
    );
  }

  // // No direction determined yet - show entire path in gray
  // if (fullPath.length > 0 && !pathDirection) {
  //   return (
  //     <Polyline
  //       path={fullPath}
  //       options={{
  //         strokeColor: "#808080",
  //         strokeOpacity: 0.7,
  //         strokeWeight: 6,
  //       }}
  //     />
  //   );
  // }

  // // Direction determined - show traveled (gray) and upcoming (colored) paths
  // if (fullPath.length > 0 && pathDirection) {
  //   return (
  //     <>
  //       {routePaths.before.length > 0 && (
  //         <Polyline
  //           path={routePaths.before}
  //           options={{
  //             strokeColor: "#808080",
  //             strokeOpacity: 0.7,
  //             strokeWeight: 6,
  //           }}
  //         />
  //       )}
  //       {routePaths.after.length > 0 && (
  //         <Polyline
  //           path={routePaths.after}
  //           options={{
  //             strokeColor: routeColor || "#2196F3",
  //             strokeOpacity: 1,
  //             strokeWeight: 6,
  //           }}
  //         />
  //       )}
  //     </>
  //   );
  // }

  return null;
};

export default RoutePolylines;